<template>
    <div class="dropdown">
        <a 
            :id="'dropdown-menu-link-'+ index" 
            class="btn dropdown-toggle" 
            v-bind:class="{'is-invalid': !isValid, 'no-selection': !selectedOption}" 
            @click="dropdown()" 
            role="button" 
            data-toggle="dropdown" 
            aria-expanded="false"
        >
            <span>{{headingTitle}}</span>
        </a>
        <div v-if="canClear" @click="clearClicked" class="clear-area"></div>
        <div class="dropdown-menu px-1" :ref="'dropdown-' + index" :aria-labelledby="'dropdown-menu-link'+ index">
            <a 
                v-for="option in options" 
                :key="option.key" 
                class="dropdown-item" 
                :class="{'dropdown-item-selected': isOptionSelected(option.key)}" 
                @click="optionClick(option)"
            >
                {{option.label}}
            </a>
        </div>     
    </div>
</template>
<script>

export default {
    data(){
        return{
            selectedOption: null
        }
    },
    props:{
        value:
        {
            type: String|Number,
            default: null
        },
        index: Number,
        options:
        {
            type: Array,
            default: () => []
        },
        title:
        {
            type: String,
            default: ""
        },
        canClear:
        {
            type: Boolean,
            default: false
        },
        isValid:
        {
            type: Boolean,
            default: true
        }
    },
    computed:
    {
        headingTitle: function()
        {
            var result = this.title;

            if(this.selectedOption)
            {
                result = this.selectedOption.label;
            }

            return result;
        }
    },
    mounted: function()
    {
        if(this.value)
        {
            var defaultValue = this.value;
            this.selectedOption = this.options.find(obj => {
                return obj.key === defaultValue
            });
        }

        document.addEventListener('click', this.handleClickOutside);
    },
    methods:{
        clearClicked()
        {
            this.selectedOption = null;
        },
        dropdown() {
            // Note that for date clicks are handled by the input
            this.$refs['dropdown-'+this.index].classList.toggle('showDropdown');
        },
        optionClick(option){
            this.selectedOption = option;
            this.$refs['dropdown-'+this.index].classList.remove("showDropdown");
        },
        handleClickOutside(evt) {
            if (!this.$el.contains(evt.target)) {
                if(this.$refs['dropdown-'+this.index] !== undefined)
                {
                    this.$refs['dropdown-'+this.index].classList.remove("showDropdown");
                }
            }
        },
        isOptionSelected(option)
        {
            return this.selectedOption && this.selectedOption.key ? this.selectedOption.key == option : false;
        },
    },
    watch:
    {
        value: function(val)
        {
            this.selectedOption = this.options.find(obj => {
                return obj.key === val
            });
        },
        selectedOption: function(val)
        {
            var value = val ? val.key : null;
            this.$emit('input', value);
        }
    }  
}
</script>

<style scoped>
.no-selection
{
    color: #AAAAAA;
}

.clear-area
{
    position: absolute;
    right: 0;
    width: 40px;
    height: 100%;
    top: 0;
    cursor: pointer;
}

.dropdown-clear::after
{
    content: "x";
    display: contents;
    font-weight: bold;
}

.dropdown-toggle
{
    min-width: 125px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-color: #d8dbe0;
    border-radius: 0.25rem;
    white-space: normal;
}
.dropdown-item-selected
{
  text-decoration: none;
  color: #fff !important;
  background-color: #2b86c5 !important;
}
.disabled .dropdown-toggle
{
    pointer-events: none;
}

.dropdown-toggle.is-invalid
{
    border-color: #e55353;
}

.dropdown-toggle.is-invalid::after
{
    color: #e55353;
}

.in-front
{
    z-index: 999;
}

.showDropdown
{
    display: block;
}

</style>